import type { PurchaseRequestDetailQuery } from 'generated/resources/graphql'
import { TimelineItemEmployeeFragment } from 'generated/resources/graphql'

export type ApprovalsV2ApprovalTimelineEntry =
  PurchaseRequestDetailQuery['procurement']['approvalsTimelines'][number]['entries'][number]

export type ApprovalsV2TimelineEntryAssignee = NonNullable<
  NonNullable<ApprovalsV2ApprovalTimelineEntry['assignees']>[number]
>

export type StatusType = 'positive' | 'warning' | 'critical' | 'info'
export type ItemStatus = 'completed' | 'running' | 'future' | 'rejected' | 'changesrequested' | 'overdue'

export type { TimelineItemEmployeeFragment }

export const STATUS_COLORS = {
  completed: '#10B881',
  running: '#FF9153',
  future: '#868E96',
  rejected: '#E03E3E',
  changesrequested: '#FF9153',
  overdue: '#FD812F',
  default: '#d1d5db',
} as const

export const CONNECTING_LINE_POSITION = {
  left: '15px',
  top: '36px',
  bottom: '-4px',
  width: '2px',
} as const
